import React from 'react';
import PropTypes from 'prop-types';
import PageHeader from 'components/common/PageHeader';

const ProcessTimeLine = ({ dadosProcesso, operacao }) => {
  return (
    <>
      <PageHeader title={``} titleTag="h5">
        {dadosProcesso.map(row => {
          return (
            <>
              <div>
                <div id="process">
                  <ul id="stepButtons" className="process-row nav nav-tabs">
                    {row.dt_abertura !== null &&
                      row.dt_abertura !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                          >
                            <i className="fa fa-info" height="90" />
                          </button>
                          <p>
                            ABERTURA DE PROCESSO<small>{row.dt_abertura}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step1"
                          >
                            <i className="fa fa-info fa-3x"></i>
                          </button>
                          <p>
                            ABERTURA DE PROCESSO<small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.dt_di_registro !== null &&
                      row.dt_di_registro !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step2"
                          >
                            <i className="fa fa-calendar-day fa-3x"></i>
                          </button>
                          <p>
                            EMISSÃO DU-E
                            <small>{row.dt_di_registro}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step2"
                          >
                            <i className="fa fa-calendar-day fa-3x"></i>
                          </button>
                          <p>
                            EMISSÃO DU-E<small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.dt_desembaraco !== null &&
                      row.dt_desembaraco !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            DESEMBARAÇO(CANAL)<small>{row.canal}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            DESEMBARAÇO(CANAL)<small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.conf_embarque !== null &&
                      row.conf_embarque !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            EMBARQUE<small>{row.conf_embarque}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            EMBARQUE<small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.dt_averbacao !== null &&
                      row.dt_averbacao !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step4"
                          >
                            <i className="fa fa-file-pen"></i>
                          </button>
                          <p>
                            {operacao === "E" ? "AVERBAÇÃO" : "REGISTRO D.I."}
                            <small>{row.dt_averbacao}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step ">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step4"
                          >
                            <i className="fa fa-file-pen fa-3x"></i>
                          </button>
                          <p>
                            {operacao === "E" ? "AVERBAÇÃO" : "REGISTRO D.I."}
                            <small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.conf_embarque !== null &&
                      row.conf_embarque !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            TRANSBORDO/CONEXÃO<small>{row.conf_embarque}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step3"
                          >
                            <i className="fa fa-truck-plane fa-3x"></i>
                          </button>
                          <p>
                            TRANSBORDO/CONEXÃO<small></small>
                          </p>
                        </li>
                      </>
                    )}
                    {row.conf_chegada !== null &&
                      row.conf_chegada !== '00/00/0000' ? (
                      <>
                        <li className="process-step active">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step4"
                          >
                            <i className="fa fa-calendar-check fa-3x"></i>
                          </button>
                          <p>
                            CHEGADA<small>{row.conf_chegada}</small>
                          </p>
                        </li>
                      </>
                    ) : (
                      <>
                        <li className="process-step">
                          <button
                            type="button"
                            className="btn btn-circle btn-default"
                            data-toggle="tab"
                            href="#step4"
                          >
                            <i className="fa fa-calendar-check fa-3x"></i>
                          </button>
                          <p>
                            CHEGADA<small></small>
                          </p>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </>
          );
        })}
      </PageHeader>
    </>
  );
};

ProcessTimeLine.propTypes = { dadosProcesso: PropTypes.object, operacao: PropTypes.string.isRequired };

export default ProcessTimeLine;
